import type { PropsWithChildren, ReactNode } from "react"

import * as styles from "./reserve-space.styled"

type ReservedSpaceProps = PropsWithChildren<{
  reserved: ReactNode
  className?: string
}>

/**
 * Allow to reserve space for a component. This is useful when you want to
 * reserve space for a component that will be rendered asynchronously or when
 * you want to reserve space for a component that will be rendered conditionally
 * (e.g. a button that will be rendered only on mobile).
 */
export const ReservedSpace = ({ children, reserved, className }: ReservedSpaceProps) => {
  return (
    <div className={styles.root}>
      <span className={styles.visibleBlock(className)}>{children}</span>
      <span className={styles.hiddenBlock} aria-hidden>
        {reserved}
      </span>
    </div>
  )
}
